<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-23 11:00:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-23 17:23:03
 -->
<template>
  <el-button type="primary" @click="loginClickHandler">没看错，我就是登陆按钮</el-button>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { pages } from '@/config'
import router from '@/router'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
    }
  },
  computed: mapState([ 'loaded' ]),
  methods: {
    ...mapActions([
      'pageLogin',
    ]),
    loginClickHandler () {
      router.push({ path: pages.home.path })
      // this.pageLogin({
      //   username: 'testgly',
      //   password: '792681',
      // })
    },
  },
  mounted () {
    this.loaded && this.$router.push(pages.home.path)
  },
}
</script>
